import React from 'react';
import NextHead from 'next/head';
import domainUtils from '../../util/domainUtils';

type SsrHeadProps = {
  productKey?: string;
  categoryKey?: string;
  isKit?: boolean;
};

const SsrHead = ({ productKey, categoryKey, isKit = false }: SsrHeadProps) => {
  const domain = domainUtils.getZolaDomain();
  const getLink = () => {
    const base = `${domain}/shop`;
    if (categoryKey) return `${base}/category/${categoryKey}`;
    if (isKit) return `${base}/kit/${productKey}`;
    return `${base}/product/${productKey}`;
  };
  return (
    <NextHead>
      <link rel="canonical" href={getLink()} />
    </NextHead>
  );
};

export default SsrHead;
